var Wallop = require("wallop");

/**
 * Selector Image Gallery
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var SelectorImageGallery = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  // init'ing our title container
	this.$titleContainer = this.options.$el.find(".directory-title-container");
	this.$titleString = this.$titleContainer.find(".title");
	this.hasDirectoryTitle = this.$titleContainer.length;

  if(this.hasDirectoryTitle){
		this.titles = this.$titleContainer.data("titles").split("|");
		this.urls = this.$titleContainer.data("urls").split("|");
	}

};

/**
 * Init'ing
 * @return {[type]} [description]
 */
SelectorImageGallery.prototype.init = function(){

  var self = this;
  var el = this.options.$el.find(".Wallop")[0];
  this.$gallery = new Wallop(el);

  // an event triggered on the SelectorAnimated.js class
  this.options.$el.on("gotoSlide", function(e, options){

  	self.$gallery.goTo(options.index);

  	if(self.hasDirectoryTitle){
			self.$titleString.text(self.titles[options.index]);
			self.$titleContainer.attr("href", self.urls[options.index]);
		}

  });

};

export default  SelectorImageGallery;
